var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._b({},'div',_vm.$attrs,false),[_c('label',{staticClass:"checkbox"},[_c('input',{attrs:{"disabled":_vm.disabled,"required":_vm.required,"type":"checkbox"},domProps:{"checked":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.checked)}}}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.label)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }